(function () {
	'use strict';

	angular.module('app.core')
		.directive('projectedShortagesChart', projectedShortagesChart);

	function projectedShortagesChart($window, $filter, $timeout, $translate,
			integerFormatService) {
		return {
			restrict: 'A',
			scope: {},
			link: function (scope, elem, attrs) {
				var scopeAccessor = scope.$parent;
				scope.chartData = scopeAccessor.chartData;
				var chart;
				var chartListener;
				var numAxisTicks = 3;
				var loadEvent = false;

				var w = angular.element($window);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				// give element unique id
				elem[0].id = elem[0].id + scope.$id;
				var chartHeight = 250;
				if (scope.chartHeight) {
					chartHeight = scope.chartHeight;
				}

				var slideshow = false;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					slideshow = true;
					scope.paddingTop = 8;
					numAxisTicks = 5;
					scope.paddingBottom = 12;
				}
				setPadding();

				scope.$watch(getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;

					setPadding();

					if (loadEvent && (currentPaddingLeft !== scope.paddingLt || newValue.h !== oldValue.h || slideshow)) {
						$timeout(generateChart);
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function getWindowDimensions2() {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				}

				function setPadding() {
					if (slideshow) {
						chartHeight = scope.height - 130 - 65;
						scope.paddingLt = 75;
						scope.paddingRt = 22;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLt = 59;
						scope.paddingRt = 15;
						scope.axisLabelWidth = 50;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLt = 48;
						scope.paddingRt = 12;
						scope.axisLabelWidth = 50;
					} else {
						scope.paddingLt = 36;
						scope.paddingRt = 12;
						scope.axisLabelWidth = 30;
					}
				}

				function generateChart() {
					if (scopeAccessor.showEditConfig) {
						return;
					}
					var i;
					var names = {
						'itemCount': $translate.instant('Items in Projected Shortages')
					};
					var data = scopeAccessor.chartData ? scopeAccessor.chartData : [];
					var dateList = [];
					var dateFormatter = scopeAccessor.settings.bucketType === 'months' ? 'MMM yyyy': 'MMM dd';
					var firstLabel = scopeAccessor.settings.bucketType === 'months' ? 'This Month': 'Next Week';
					angular.forEach(data, function (dp) {
						dateList.push($filter('date')(dp.date, dateFormatter, 'UTC'));
					});
					var startTimestamp = (data && data.length) ? data[0].date : 0;
					var endTimestamp = (data && data.length) ? data[data.length - 1].date : 0;
					// one day
					var noOfDays = scopeAccessor.settings.bucketType === 'months' ? 30 : 7;
					var interval = noOfDays * 60 * 60 * 24 * 1000;

					var possiblePoints = Math.ceil((endTimestamp - startTimestamp) / interval) + 1;
					var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLt - scope.paddingRt;
					var barWidth = chartWidth / possiblePoints;
					var max = 0;
					if (data && data.length) {
						max = data[0]['itemCount'];
						for (var i = 0; i < data.length; i++) {
							if (data[i]['itemCount'] > max) {
								max = data[i]['itemCount'];
							}
						}
					}
					var multiple = numAxisTicks - 1;
					// get a max value with a ~5% buffer that cleanly divides by number of ticks
					var yMax = Math.ceil(max * 1.05 / multiple) * multiple;
					var config = {};
					// tell c3 where to put the chart
					config.bindto = '#' + elem[0].id;
					config.size = {
						height: chartHeight
					};
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt,
						top: scope.paddingTop
					};

					config.bar = {
						width: barWidth * 0.5
					};

					config.data = {
						json: data,
						type: 'bar',
						keys: {
							value: ['itemCount']
						},
						names: names
					};

					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};

					config.axis = {
						rotated: false,
						x: {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								outer: false,
								multiline: false,
								format: function(d) {
									return d === 0 ? firstLabel: dateList[d];
								}
							}
						},
						y: {
							tick: {
								format: function (x) {
									return integerFormatService.get(x);
								},
								count: numAxisTicks
							},
							min: 0,
							max: yMax,
							padding: {
								bottom: 0,
								top: 0
							}
						}
					};
					config.legend = {
						show: false
					};
					config.tooltip = {
						format: {
							title: function(x) {
								return dateList[x];
							}
						}
					};
					chart = c3.generate(config);
				}

				scope.$watch(function () {
					return jQuery('.projectd-shortages-chart .c3-legend-item-tile').last().attr('x1');
				});

				chartListener = scope.$on('event:projectedShortagesCtrl:getChart', function () {
					loadEvent = true;
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (chartListener) {
						chartListener();
					}
				});
			}
		};
	}
})();
